// Dados fictícios para o PMS (mock)
export const reservasMock = [
  { id: 'R001', hospede: 'Ana Souza', quarto: '101', checkin: '2025-08-18', checkout: '2025-08-20', status: 'Confirmada', valor: 520.0 },
  { id: 'R002', hospede: 'Bruno Lima', quarto: '203', checkin: '2025-08-19', checkout: '2025-08-22', status: 'Pendente', valor: 780.0 },
  { id: 'R003', hospede: 'Carla Nunes', quarto: '305', checkin: '2025-08-20', checkout: '2025-08-21', status: 'Cancelada', valor: 0.0 },
];

export const hospedesMock = [
  { id: 'H001', nome: 'Ana Souza', documento: '123.456.789-00', telefone: '(11) 91234-5678', email: 'ana@example.com' },
  { id: 'H002', nome: 'Bruno Lima', documento: '987.654.321-00', telefone: '(21) 99876-5432', email: 'bruno@example.com' },
  { id: 'H003', nome: 'Carla Nunes', documento: '111.222.333-44', telefone: '(31) 90000-1111', email: 'carla@example.com' },
];

export const quartosMock = [
  { numero: '101', tipo: 'Standard', status: 'Livre', diaria: 260.0 },
  { numero: '203', tipo: 'Luxo', status: 'Ocupado', diaria: 390.0 },
  { numero: '305', tipo: 'Standard', status: 'Manutenção', diaria: 260.0 },
  { numero: '402', tipo: 'Suíte', status: 'Livre', diaria: 520.0 },
];

export const lancamentosMock = [
  { id: 'L001', data: '2025-08-18', descricao: 'Diária 101', tipo: 'Credito', valor: 260.0 },
  { id: 'L002', data: '2025-08-19', descricao: 'Café da manhã', tipo: 'Credito', valor: 40.0 },
  { id: 'L003', data: '2025-08-19', descricao: 'Estorno taxa', tipo: 'Debito', valor: -20.0 },
];

export const kpisMock = {
  ocupacaoHoje: 72,
  revpar: 185.4,
  adr: 257.9,
  reservasPendentes: 4,
};
